import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface UseRenewalConfirmationReturn {
  showConfirmationModal: boolean;
  confirmationMessage: string;
  closeConfirmationModal: () => void;
}

/**
 * Hook to handle academic renewal confirmation from URL parameters
 * Detects when user is redirected from email confirmation link
 */
export const useRenewalConfirmation = (): UseRenewalConfirmationReturn => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const renewalConfirmed = urlParams.get('renewal_confirmed');
    const message = urlParams.get('message');

    if (renewalConfirmed === 'true') {
      setShowConfirmationModal(true);
      setConfirmationMessage(
        message || 'Your academic license renewal has been confirmed successfully'
      );

      // Clean up URL parameters without triggering a page reload
      const cleanUrl = window.location.pathname;
      navigate(cleanUrl, { replace: true });
    }
  }, [location.search, navigate]);

  const closeConfirmationModal = () => {
    setShowConfirmationModal(false);
    setConfirmationMessage('');
  };

  return {
    showConfirmationModal,
    confirmationMessage,
    closeConfirmationModal,
  };
};